/* eslint-disable react/prop-types */
import { Avatar, Box, CircularProgress, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Link from 'next/link';
import { useRouter } from 'next/router';
import Scrollbar from '../../components/Scrollbar';
import useSettings from '../../hooks/useSettings';

// ----------------------------------------------------------------------
export default function MenuSection({ streetExams }) {
  let theme = useTheme();
  const { themeStretch } = useSettings();

  return (
    <Box>
      <Scrollbar sx={{ maxHeight: themeStretch ? 590 : 450 }}>
        <Stack>
          <Box p={1} bgcolor={theme.palette.primary.dark}>
            <Typography variant='subtitle1' color={'#fff'}>Bài thi đường trường ô tô</Typography>
          </Box>
          {streetExams?.map((s) => <SituationItem key={s.id} item={s} />)}
        </Stack>
      </Scrollbar>
    </Box>
  );
}

function SituationItem({ item }) {
  let theme = useTheme();

  const router = useRouter();
  const pathname = router.asPath.replace(`/thi-duong-truong/`, '').replace("/", '');

  const { slug, title, orderNo } = item;
  const isActive = pathname === slug || (pathname === '' && orderNo === 1);

  return (
    <Link href={`/thi-duong-truong/${slug}`} passHref scroll={false}>
      <Stack direction="row" spacing={2} alignItems="center" bgcolor={theme.palette.background.neutral} my={0.5} py={1.2} sx={{ cursor: 'pointer', borderRadius: 0.5 }} >
        {!isActive &&
          <Avatar sx={{ bgcolor: theme.palette.text.secondary, color: theme.palette.background.default }} variant="rounded">{orderNo}</Avatar>
        }
        {isActive &&
          <Box sx={{ position: 'relative', display: 'inline-flex', borderRadius: 1, backgroundColor: theme.palette.text.secondary }}>
            <CircularProgress />
            <Box sx={{ top: 0, left: 0, bottom: 0, right: 0, position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
              <Typography variant="h5" color={theme.palette.background.default}>{orderNo}</Typography>
            </Box>
          </Box>}
        <Typography variant="subtitle2" color={theme.palette.text.primary} fontWeight={500}>
          {title}
        </Typography>
      </Stack>
    </Link>
  );
}
